import { render, staticRenderFns } from "./CommunityBNavigationBar.vue?vue&type=template&id=4a3ac964&scoped=true"
import script from "./CommunityBNavigationBar.vue?vue&type=script&lang=js"
export * from "./CommunityBNavigationBar.vue?vue&type=script&lang=js"
import style0 from "./CommunityBNavigationBar.vue?vue&type=style&index=0&id=4a3ac964&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3ac964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a3ac964')) {
      api.createRecord('4a3ac964', component.options)
    } else {
      api.reload('4a3ac964', component.options)
    }
    module.hot.accept("./CommunityBNavigationBar.vue?vue&type=template&id=4a3ac964&scoped=true", function () {
      api.rerender('4a3ac964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/CommunityBNavigationBar.vue"
export default component.exports